import { UserDefinedInformationWindowKinds } from "../../../../../../../documaker/domain/format/objects";
import { IXElementContentsObjectBean, IXElementContentsObjectRelationalBean } from "../../../beans";
import { IntegerTranslator } from "../../values";
import { RelationTranslator } from "./RelationTranslator";

export class UserDefinedInformationWindowKindTranslator {
  from(bean: IXElementContentsObjectBean): UserDefinedInformationWindowKinds {
    return this.relationalItems.from(
      bean,
      is => this.integer.from(is[0]["@option"]),
      UserDefinedInformationWindowKinds.Normal);
  }

  to(object: UserDefinedInformationWindowKinds): IXElementContentsObjectRelationalBean {
    return this.relationalItems.to([
      {
        "@option": this.integer.to(object),
      },
    ]);
  }
  private readonly relationalItems = new RelationTranslator("window-type");
  private readonly integer = new IntegerTranslator();
}
